import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=2c6adcec&scoped=true"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6adcec",
  null
  
)

export default component.exports